<template>
	<div class="">
		<ErrorModal
			v-if="showErrorModal"
			id="errorModal"
			@return="showErrorModal = false; email=''"
			:message="errorMessage"
		/>
		<SuccessModal v-if="showSuccessModal" id="successModal" :message="'If a matching account was found an email will be sent to '+email+' to allow you to reset your password.'" @return="showSuccessModal=false; $router.push('/')"/>
		<form class="space-y-4" @submit.prevent>
			<!-- title -->
			<div class="text-center">
				<h1 class="text-xl font-medium">Forgotten your password?</h1>
				<h1 class="text-sm sm:text-md font-light pt-1 pb-3">Enter your email to reset your password</h1>
			</div>

			<!-- email input -->
			<CustomInput
				v-model="email"
				id="emailInput"
				placeholder="Email"
				name="email"
				type="email"
				:error="errors.email"
				bigInput
			/>
			<!-- sign in button -->
			<CustomButton
				id="resetButton"
				text="Reset password"
				color="gray-800"
				class="py-3"
				:disabled="disabled"
				@click="forgotPassword()"
			/>
		</form>
	</div>
</template>

<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import ErrorModal from '@/components/modals/ErrorModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';

export default {
	name: "SignIn",
	components: {
		CustomInput,
		CustomButton,
		ErrorModal,
		SuccessModal
	},
	props:{
		backdoorKey:{
			type:String
		}},
	data() {
		return {
			email: "",
			errors:{},
			showErrorModal:false,
			showSuccessModal:false
		}
	},
	methods: {
		async forgotPassword(){
			try {
				var body = {
					email:this.email
				}
				const token = localStorage.getItem('token')
                this.loading = true

				const response = await fetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/auth/forgot-password`, {
					method: "POST",
					body:JSON.stringify(body),
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					this.showSuccessModal = true

				}
				
			} catch (error) {
				return;
			}

		},


	},
	computed: {
		disabled: function(){
			if(this.email.length == 0) return true
			if(!this.email.includes("@")) return true
			return false
		}
	
	},
	mounted() {
        document.title = "Forgot password";
    },
	watch: {

	}
}
</script>

<style >
</style>

